import { createContext, useContext } from "react";
import type { Session, SupabaseClient } from "@supabase/supabase-js";

export type SocialProvider = "google" | "facebook";

export interface AuthContextValue {
  readonly client: SupabaseClient | null;
  readonly session: Session | null;
  readonly loading: boolean;
  readonly error: string | null;
  readonly socialProviders: Readonly<Record<SocialProvider, boolean>>;
}

export const AuthContext = createContext<AuthContextValue | undefined>(undefined);

export function useAuth(): AuthContextValue {
  const value = useContext(AuthContext);
  if (value === undefined) throw new Error("useAuth must be used inside AuthProvider");
  return value;
}
